import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import '../css/EntityDetailsAdmin.css';
import UserPanelSidebar from "../components/UserPanelSidebar";

const EntityDetailsAdmin = () => {
    const [entities, setEntities] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEntities = async () => {
            const querySnapshot = await getDocs(collection(db, 'entities'));
            const entitiesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setEntities(entitiesData);
        };

        fetchEntities();
    }, []);

    // Sorting logic
    const sortedEntities = [...entities].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const aVal = a[sortConfig.key] || '';
        const bVal = b[sortConfig.key] || '';
        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const renderSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />;
        }
        return <FaSort />;
    };

    const handleEditClick = (entityId) => {
        navigate(`/entityDetailsAdmin/${entityId}`);
    };

    return (
        <div className="entity-details-admin">
            <UserPanelSidebar />
            <div className="entity-details-admin-container">
                <table className="entity-table">
                    <thead>
                    <tr>
                        <th onClick={() => requestSort('id')}>Id {renderSortIcon('id')}</th>
                        <th onClick={() => requestSort('entity_name')}>Name {renderSortIcon('entity_name')}</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sortedEntities.map((entity) => (
                        <tr key={entity.id}>
                            <td>{entity.id}</td>
                            <td>{entity.entity_name || 'N/A'}</td>
                            <td>
                                <button
                                    className="edit-button"
                                    onClick={() => handleEditClick(entity.id)}
                                >
                                    <FaEdit />
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EntityDetailsAdmin;
